import { endPoint } from './base.config';

export const transactionImport = {
  index: `${endPoint}bankImport`,
  delete: `${endPoint}bankImport/:importId`,
};
